<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="items" sticky-header responsive no-border-collapse show-empty>

            <template #empty>
                <b-card class="text-center my-2 fs-5">
                    Aún no se ha agregado ningún tipo
                </b-card>
            </template>

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';

export default {
    name: 'KarinListTypes',

    components: {
        AlertDismiss
    },

    async mounted(){
        await this.getAll();

        this.$eventBus.$on(EventNames.KarinCreatedType, async () => {
            this.cargandoTabla();
            await this.getAll();
            this.cargandoTabla();
        });
    },

    data() {
        return {
            isBusy: false,

            fields: [
                { key: 'type', label: 'Tipo' },
            ],

            items: []
        }
    },

    methods:{
        ...mapActions(["getKarinDenunciationTypes"]),

        cargandoTabla(){
            this.isBusy = ! this.isBusy;
        },

        async getAll(){
            this.cargandoTabla();
            let result = await this.getKarinDenunciationTypes();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.cargandoTabla();
                return;
            }

            this.items = result.data.map(x => ({type: x.name}))

            this.cargandoTabla();
        },
    }
}
</script>
